import React from 'react';

import IFormatterEntry from 'common/types/IFormatterEntry';

const WorkerLabels = ({ entry }: IFormatterEntry) => entry ? (
  <div className='label'>{entry as React.ReactNode}</div>
) : null;


export default WorkerLabels;
